module.exports = __webpack_public_path__ + "static/media/sumavigroup ui-05.9918d655.png";